const config = require('../config.js');
const apiBaseUrl = config.default.api.url;
const apiKey = config.default.api.key;

export const queryDocuments = async (userId, queryText, preferences = '', token = '') => {
  try {
    const response = await fetch(`${apiBaseUrl}/query`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId: userId,
        text: queryText,
        k: 3,
        preferences: preferences
      })
    });
    
    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Unauthorized');
      }
      
      if (response.status === 429) {
        const retryAfter = response.headers.get('Retry-After') || 60;
        throw new Error(`Rate limit exceeded. Please try again after ${retryAfter} seconds.`);
      }
      
      throw new Error(`Error: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error querying documents:', error);
    throw error;
  }
};
